import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Divider, Empty, message, Select, Spin } from "antd";

import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import "./MemberPage.css";
import ClubBoxWidget from "components/ClubBoxWidget/ClubBoxWidget";
import {
  apiDeleteRegInfo,
  apiGetRegistrationDetail,
  apiGetRegistrationDetailByGroup,
  apiGetRegistrationList,
  apiUpdateRegInfo,
  apiUpdateCampRegInfo,
} from "services/dashboardService";
import RegFormTable from "./RegFormTable/RegFormTable";
import SearchWidget from "./SearchWidget/SearchWidget";
import GroupTable from "./GroupTable/GroupTable";

import { showMessageOneModal } from "./MessageOneModal/showMessageOneModal";
import { apiSendMessage } from "services/divisionService";
import RightDetailWidget from "./RightDetailWidget/RightDetailWidget";
import CampRightDetailWidget from "pages/RegistrationPage/RightDetailWidget/CampRightDetailWidget";
const MemberPage = (props) => {
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const [isBusy, setIsBusy] = useState(false);
  const [userList, setUserList] = useState([]);
  const [srcList, setSrcList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [srcGroupList, setSrcGroupList] = useState([]);
  const [tripList, setTripList] = useState([]);
  const [groupVal, setGroupVal] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [isGroup, setIsGroup] = useState(false);
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState({});
  const [groupLabel, setGroupLabel] = useState("");
  const [telePhone, setTelephone] = useState("");
  const [homePhone, setHomephone] = useState("");
  const [cellPhone, setCellphone] = useState("");
  const [contactPhone, setContactPhone] = useState("");

  const [mClub, setMClub] = useState({
    id: "",
    name: "",
  });
  const [mRegistration, setMRegistration] = useState({
    ID: "",
    registration_name: "",
  });
  useEffect(() => {
    if (mRegistration != undefined && mRegistration.ID != "") {
      getRegistrationDetail();
    } else {
      setUserList([]);
      setSrcList([]);
    }
  }, [mRegistration]);

  useEffect(() => {
    if (mRegistration == undefined || mRegistration.ID == "") {
      setGroupVal("");
      return;
    }
    if (groupVal != "") {
      setIsGroup(true);
      getRegistrationByGroupDetail(groupVal);
      let label = "";
      if (groupVal == "fee_label") {
        label = "Registration Group";
      } else if (groupVal == "timestamp") {
        label = "Reg Date";
      } else if (groupVal == "gender") {
        label = "Gender";
      } else if (groupVal == "discount_code") {
        label = "Discount Code";
      } else if (groupVal == "payment_method") {
        label = "Payment method";
      }
      setGroupLabel(label);
    } else {
      setGroupLabel("");
    }
  }, [groupVal]);

  const onClear = () => {
    setSearchKey("");
    setGroupVal("");
    setIsGroup(false);
    setUserList(srcList);
  };
  const onSearch = (v) => {
    setSearchKey(v);
    let tmpList = [];
    if (isGroup) {
      tmpList = [...srcGroupList];
    } else {
      tmpList = [...srcList];
    }
    if (isGroup) {
      if (v == "") {
        setGroupList(tmpList);
      } else {
        setGroupList(
          tmpList.filter((x) => {
            if (x.fee_label.toLowerCase().includes(v.toLowerCase())) {
              return x;
            }
          })
        );
      }
    } else {
      if (v == "") {
        setUserList(tmpList);
      } else {
        setUserList(
          tmpList.filter((x) => {
            if (
              x.email.toLowerCase().includes(v.toLowerCase()) ||
              x.name.toLowerCase().includes(v.toLowerCase())
            ) {
              return x;
            }
          })
        );
      }
    }
  };
  const getRegistrationDetail = () => {
    setUserList([]);
    setSrcList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", mRegistration.ID);
    params.append("sport_type", userDataStore?.sport_type);
    setIsBusy(true);
    apiGetRegistrationDetail(params)
      .then((res) => {
        setUserList(res.detail);
        setSrcList(res.detail);
        let tmpList = [...res.group_list];
        let tmpSrcList = tmpList.map((x, index) => {
          return {
            id: x.ID,
            title: x.registration_group_short_name,
            description: x.registration_group_name,
            price: x.registration_group_fee,
            checked: false,
            discount_available: x.discount_available,
          };
        });
        setTripList(tmpSrcList);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const getRegistrationByGroupDetail = (group) => {
    setGroupList([]);
    setSrcGroupList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("id", mRegistration.ID);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("group", group);
    setIsBusy(true);
    apiGetRegistrationDetailByGroup(params)
      .then((res) => {
        setGroupList(res);
        setSrcGroupList(res);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const updateCampData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", userData.id);

    params.append("camper_first_name", userData.camper_first_name);
    params.append("camper_last_name", userData.camper_last_name);
    params.append("camper_age", userData.camper_age);
    params.append("camper_grade", userData.camper_grade);
    params.append("camper_street", userData.camper_street);
    params.append("camper_city", userData.camper_city);
    params.append("camper_state", userData.camper_state);
    params.append("camper_zip", userData.camper_zip);
    params.append("camper_health", userData.camper_health);
    params.append("camper_sel_trip", userData.camper_sel_trip);
    params.append("camper_t_shirt", userData.camper_t_shirt);
    params.append("p_first_name", userData.p_first_name);
    params.append("p_last_name", userData.p_last_name);
    params.append("p_relation", userData.p_relation);
    params.append("p_email", userData.p_email);
    params.append("p_cell_phone", userData.p_cell_phone);
    params.append("p_home_phone", userData.p_home_phone);
    params.append("c_first_name", userData.c_first_name);
    params.append("c_last_name", userData.c_last_name);
    params.append("c_email", userData.c_email);
    params.append("c_cell_phone", userData.c_cell_phone);
    setIsBusy(true);
    apiUpdateCampRegInfo(params)
      .then((res) => {
        let selData = {
          ...userData,
          name: userData.camper_first_name + " " + userData.camper_last_name,
        };
        let tmpList = [...userList];
        let selId = tmpList.findIndex((x) => x.id == userData.id);
        tmpList[selId] = selData;
        setUserList(tmpList);
        let tmpSrcList = [...srcList];
        let selsrcId = tmpSrcList.findIndex((x) => x.id == userData.id);
        tmpSrcList[selsrcId] = selData;
        setSrcList(tmpSrcList);
        message.success("Updated successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const updateData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("id", userData.id);
    params.append("first_name", userData.first_name);
    params.append("last_name", userData.last_name);
    params.append("email", userData.email);
    params.append("tele_phone", userData.tele_phone);
    params.append("birthday", userData.birthday);
    params.append("address", userData.address);
    params.append("city", userData.city);
    params.append("state", userData.state);
    params.append("gender", userData.gender);
    params.append("zip", userData.zip);
    params.append("grade", userData.grade);
    params.append("fee_label", userData.fee_label);
    params.append("p_first_name", userData.p_first_name);
    params.append("p_home_phone", userData.p_home_phone);
    params.append("p_last_name", userData.p_last_name);
    params.append("p_cell_phone", userData.p_cell_phone);
    params.append("p_relation", userData.p_relation);
    params.append("p_email", userData.p_email);
    params.append("c_first_name", userData.c_first_name);
    params.append("c_last_name", userData.c_last_name);
    params.append("c_email", userData.c_email);
    params.append("c_cell_phone", userData.c_cell_phone);
    setIsBusy(true);
    apiUpdateRegInfo(params)
      .then((res) => {
        let selData = {
          ...userData,
          name: userData.first_name + " " + userData.last_name,
        };
        let tmpList = [...userList];
        let selId = tmpList.findIndex((x) => x.id == userData.id);
        tmpList[selId] = selData;
        setUserList(tmpList);
        let tmpSrcList = [...srcList];
        let selsrcId = tmpSrcList.findIndex((x) => x.id == userData.id);
        tmpSrcList[selsrcId] = selData;
        setSrcList(tmpSrcList);
        message.success("Updated successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const deleteData = (id) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", id);
    setIsBusy(true);
    apiDeleteRegInfo(params)
      .then((res) => {
        let tmpList = [...userList];
        setUserList(tmpList.filter((x) => x.id != id));
        message.success("Deleted successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const sendMessage = async (info) => {
    var resInfo = await showMessageOneModal({
      title: "Send Mail",
      token: userDataStore.token,
      toEmail: info.email,
    });
    if (resInfo == null) return;
    let messageTitle = "MW REC BASKETBALL";
    let tmpClub = userDataStore.clubs.filter((x) => x.CLUB_OR_TEAM == "1");
    if (tmpClub.length > 0) {
      messageTitle = tmpClub[0].CLUB_TEAM_INFO.NAME;
    }
    setIsBusy(true);
    let params = {
      token: userDataStore.token,
      sport_type: userDataStore.sport_type,
      user_id: userDataStore.user.ID,
      toID: info.id,
      toName: info.name,
      toEmail: info.email,
      subject: resInfo.subject,
      content: resInfo.content,
      attachment: resInfo.attachment,
      message_title: messageTitle,
      registration_id: appDataStore.curRegistration.ID
    };
    apiSendMessage(params)
      .then((res) => {
        message.success("Message sent successfully");
        setIsBusy(false);
      })
      .catch((err) => {
        message.error(err);
        setIsBusy(false);
      });
  };
  const onVisible = (info) => {
    setVisible(true);
    setTelephone(info.tele_phone);
    setHomephone(info.p_home_phone);
    setCellphone(info.p_cell_phone);
    setContactPhone(info.c_cell_phone);
  };
  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <div className="registration-page">
          <ClubBoxWidget
            type="member"
            mClub={mClub}
            setMClub={setMClub}
            mRegistration={mRegistration}
            setMRegistration={setMRegistration}
          />
          <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Divider
              style={{ borderTop: "4px solid var(--mainColor)" }}
            ></Divider>
            <SearchWidget
              dataList={userList}
              groupList={groupList}
              isGroup={isGroup}
              groupVal={groupVal}
              setGroupVal={setGroupVal}
              onClear={onClear}
              onSearch={onSearch}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              sport_type={userDataStore?.sport_type}
            />
            {isGroup ? (
              <GroupTable
                dataList={groupList}
                group={groupLabel}
                sport_type={userDataStore?.sport_type}
              />
            ) : (
              <RegFormTable
                dataList={userList}
                setVisible={onVisible}
                sendMessage={sendMessage}
                setUserData={setUserData}
                deleteData={deleteData}
                sport_type={userDataStore?.sport_type}
              />
            )}
          </div>
          {userDataStore?.sport_type == "camp" ? (
            <CampRightDetailWidget
              visible={visible}
              setVisible={setVisible}
              userData={userData}
              setUserData={setUserData}
              updateData={updateCampData}
              telePhone={telePhone}
              setTelephone={setTelephone}
              homePhone={homePhone}
              setHomephone={setHomephone}
              cellPhone={cellPhone}
              setCellphone={setCellphone}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
              tripList={tripList}
            />
          ) : (
            <RightDetailWidget
              visible={visible}
              setVisible={setVisible}
              userData={userData}
              setUserData={setUserData}
              updateData={updateData}
              telePhone={telePhone}
              setTelephone={setTelephone}
              homePhone={homePhone}
              setHomephone={setHomephone}
              cellPhone={cellPhone}
              setCellphone={setCellphone}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
            />
          )}
        </div>
      </Spin>
    </CommonDivWidget>
  );
};

export default MemberPage;
